import { Link } from "react-router-dom";

const App = () => {
    return (
        <>
            <div className={"text-center"}>
                <Link to={"/cross"}>
                    <button className={"btn btn-success mx-10"}>
                        کراس
                    </button>
                </Link>
                <Link to={"/market"}>
                    <button className={"btn btn-success mx-10"}>
                        سیگنال بازار
                    </button>
                </Link>
                <Link to={"/market/users"}>
                    <button className={"btn btn-success mx-10"}>
                        سیگنال بازار کاربران
                    </button>
                </Link>
                <Link to={"/market/realtime"}>
                    <button className={"btn btn-success mx-10"}>
                        سیگنال بازار درلحظه
                    </button>
                </Link>
                <Link to={"/comment"}>
                    <button className={"btn btn-success mx-10"}>
                        کامنت
                    </button>
                </Link>
                <Link to={"/justify"}>
                    <button className={"btn btn-success mx-10"}>
                        تعدیل قیمت
                    </button>
                </Link>
                <Link to={"/strategy"}>
                    <button className={"btn btn-success mx-10"}>
                        استراتژی
                    </button>
                </Link>
                <Link to={"/filters"}>
                    <button className={"btn btn-success mx-10"}>
                        فیلترهای کاربردی بورس
                    </button>
                </Link>
                <Link to={"/calculators"}>
                    <button className={"btn btn-success mx-10"}>
                        ماشین حساب
                    </button>
                </Link>
            </div>

        </>
    )
};
export default App